import { render, staticRenderFns } from "./AboutUsLink.vue?vue&type=template&id=3cac1a1b&"
import script from "./AboutUsLink.vue?vue&type=script&lang=js&"
export * from "./AboutUsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports